/**
 * @generated SignedSource<<7c08a874c3bcf7f3ba217f8986fda005>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type WidgetNoteFontSize = "LARGE" | "MEDIUM" | "SMALL";
export type WidgetNoteFontStyle = "BOLD" | "CURSIVE" | "DEFAULT";
import { FragmentRefs } from "relay-runtime";
export type TextControl_widgetNotePage$data = {
  readonly backgroundColor: string | null;
  readonly fontSize: WidgetNoteFontSize;
  readonly fontStyle: WidgetNoteFontStyle;
  readonly id: string;
  readonly image: {
    readonly __typename: "Image";
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"useNoteWidgetStyleText_widgetNotePage" | "useToggleFontColor_page">;
  readonly " $fragmentType": "TextControl_widgetNotePage";
};
export type TextControl_widgetNotePage$key = {
  readonly " $data"?: TextControl_widgetNotePage$data;
  readonly " $fragmentSpreads": FragmentRefs<"TextControl_widgetNotePage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TextControl_widgetNotePage",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fontSize",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fontStyle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "backgroundColor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "image",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useToggleFontColor_page"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useNoteWidgetStyleText_widgetNotePage"
    }
  ],
  "type": "WidgetNotePage",
  "abstractKey": null
};

(node as any).hash = "7bd223583119ffa59db38e059d11b772";

export default node;
